import { CadastroReferenciaPage } from '../pages/cadastro-referencia/cadastro-referencia';
import { ListaPedidoPage } from '../pages/lista-pedido/lista-pedido';
import { ListaPixPage } from '../pages/lista-pix/lista-pix';
import { InformacoesPessoaisPage } from '../pages/informacao-pessoal/informacao-pessoal';
import { ReceberCartelaPage } from '../pages/receber-cartela/receber-cartela';
import { AppModule } from '../app/app.module';
//https://ionicframework.com/docs/v3/ionicons/
export class MenuHelper {
    private static _menuVendedor: { icon: string, describe: string, page: any }[] = [     
        { icon: 'md-medal', describe: 'Acompanhar Brinde', page: ListaPedidoPage } , 
        { icon: 'ios-list-box', describe: 'Informações pessoais', page: InformacoesPessoaisPage }
    ];

    private static _menuVendedorPix: { icon: string, describe: string, page: any }[] = [     
        { icon: 'md-medal', describe: 'Acompanhar Brinde', page: ListaPedidoPage } , 
         { icon: 'logo-usd', describe: 'Acompanhar Pix', page: ListaPixPage } , 
        { icon: 'ios-list-box', describe: 'Informações pessoais', page: InformacoesPessoaisPage }
    ];

    private static _menuAdministrador: { icon: string, describe: string, page: any }[] = [  
        { icon: 'md-medal', describe: 'Acompanhar Pedidos', page: ListaPedidoPage },    
        { icon: 'logo-usd', describe: 'Acompanhar Pix', page: ListaPixPage },
        { icon: 'md-archive', describe: 'Receber Cartela', page: ReceberCartelaPage },
        { icon: 'ios-list-box', describe: 'Referência de Brinde', page: CadastroReferenciaPage }
    ];


    public static getMenuToPrifile(profile: string,verPix: boolean): { icon: string, describe: string, page: any }[] {

        switch (profile) {
            case 'VENDEDOR':
                if (AppModule.getEmpresa().Id ===1 || verPix) {return this._menuVendedorPix} else return this._menuVendedor;
            case 'ADMINISTRADOR':
                return this._menuAdministrador;                
            default:
                break;
        }
        return this._menuVendedor;
    }
}


// WEBPACK FOOTER //
// ./src/utils/menu-helper.ts